import prop from 'ramda/src/prop'
import { getTwitchChannels, getTwitchGames } from 'root/src/client/util/twitchClientApi'
import { getYoutubeChannels } from 'root/src/client/util/youtubeClientApi'
import searchCreators from 'root/src/client/util/searchCreators'
import searchPlatformCreators from 'root/src/client/util/searchPlatformCreators'
import providers from 'root/src/shared/constants/providers'

const promiseTypeMap = {
	twitchChannels: getTwitchChannels,
	twitchGames: getTwitchGames,
	youtubeChannels: getYoutubeChannels,
	tiktokCreators: input => searchPlatformCreators({ query: input, platform: providers.tiktok }),
	creators: searchCreators,
}

export default promiseType => prop(promiseType, promiseTypeMap)
